import BaseObject from "@sourceflow-uk/sourceflow-sdk/base_object";
import data from "../.sourceflow/global.json";

export const useGlobal = () => new BaseObject(data, "en").toJson();

export default useGlobal;
